export default __webpack_public_path__ + "images/assets/f098de553a5318ed23a6f6924fc58f05.svg";